module.exports = __webpack_public_path__ + "img/paint-bucket.2c09a87f.png";